import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { first } from 'rxjs';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { FarmersDetailsService } from 'src/app/services/farmers-details.service';
import { IpAddressService } from 'src/app/services/ip-address.service';
import { VendorDashboardService } from 'src/app/services/vendor-dashboard.service';

@Component({
  selector: 'app-unhide-application',
  templateUrl: './unhide-application.component.html',
  styleUrls: ['./unhide-application.component.scss']
})
export class UnhideApplicationComponent implements OnInit {

  applicationForm: FormGroup;
  isSubmitted: boolean = false;
  userID: any;
  ipAddress: any = '000.000.000';


  constructor(
    private fb: FormBuilder,
    private loader: AppLoaderService,
    private vendorDashboardService: VendorDashboardService,
    private deptDashBoardService: DepartmentDashboardService,
    private messageService: MessageService,
    private ipService: IpAddressService,
    private uploadDocService: FarmersDetailsService,
    private cryptoJsService: CryptoJsService
  ) { }

  ngOnInit(): void {
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userID = JSON.parse(payload)?.sub;

    this.applicationForm = this.fb.group({
      applicationNo: ['', Validators.required],
      docPath: ['', Validators.required],
    });

    this.getIP();
  }

  get f() {
    return this.applicationForm.controls;
  }

  submitApplication() {
    this.isSubmitted = true;
    if (this.applicationForm.valid) {

      let reqBody = {
        appId: this.applicationForm.value['applicationNo'],
        docPath: this.applicationForm.value['docPath'],
        existingProgId: 0,
        updatedProgId: 0,
        actionId: 1,
        vendorId: '0',
        userId: this.userID,
        netWork_Id: this.ipAddress,
        terminal_Id: this.ipAddress,
      }
      this.hideAppStatus(reqBody);
    }
  }

  hideAppStatus(reqBoady) {
    let reqBodyAfterEncypt = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(reqBoady))
    }

    this.loader.start();
    this.deptDashBoardService
      .addFarmerQueries(reqBodyAfterEncypt)
      .pipe(first())
      .subscribe({
        next: (resp) => {
          this.loader.close();
          if (resp == 'Success') {
            this.messageService.add({
              severity: 'success',
              summary: 'Success Message',
              detail: resp,
            });
          } else {
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: resp,
            });
          }
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  clearAppNo() {
    this.f.applicationNo.setValue(null);
  }

  getIP() {
    if (sessionStorage.getItem('ipAddress')) {
      this.ipAddress = JSON.parse(window.sessionStorage.getItem('ipAddress'));
    } else {
      this.ipService.getIPAddress().subscribe((res: any) => {
        this.ipAddress = res.ip;
        sessionStorage.setItem('ipAddress', JSON.stringify(this.ipAddress));
      });
    }
  }

  onUpload(event, formcontrol, uploadElement) {
    let file = event.files[0];
    let data = new FormData();
    data.append('file', file);
   
    this.loader.start();
    this.uploadDocService.uploadFile(data, 'farmer_query', formcontrol)
      .subscribe(
        (resp: any) => {
          this.loader.close();
          if (resp.statusCode == 200) {
            this.applicationForm.patchValue({ [formcontrol]: resp.data });
          } else {
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: 'resp',
            });
          }
        },
        (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        }
      );

    uploadElement.clear();
  }
}
